(function () {
  'use strict';

  let isInitialized = false;
  let isProcessingRequest = false;
  let processedRequests = new Set();
  let allSizeVariants = [];
  let sizeVariantStocks = {};
  let sizeDistribution = {};
  let variantDistributions = {};
  let isBedenSetiFormat = false;
  let minStockQuantity = 0;
  let availableSizes = [];
  let internalRequestFlag = 'SET_MULTIPLIER_INTERNAL_REQUEST';
  let isPaketYapisiFormat = false;
  let paketMultiplier = 1;
  const PRODUCTION_MODE = false;

  // Debounce helper - tekrarlayan çağrıları engelle
  let debounceTimers = {};
  function debounce(key, callback, delay = 300) {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(callback, delay);
  }

  function log(...args) {
    if (!PRODUCTION_MODE) {
      console.log('[Set Multiplier]', ...args);
    }
  }

  function logError(...args) {
    console.error('[Set Multiplier Error]', ...args);
  }

  function initializeMultiplier() {
    if (!window.productVariantInfo) {
      logError('Product variant info not found');
      return false;
    }

    const info = window.productVariantInfo;
    allSizeVariants = info.allSizeVariantIds || [];
    minStockQuantity = info.minStockQuantity || 0;
    availableSizes = info.allSizes || [];

    log('Product info loaded:', info.productTitle);

    if (allSizeVariants.length === 0) {
      logError('No size variants found');
      return false;
    }

    parseVariantStocks(info.sizeVariantStocks);

    // === CANONICAL PARSER (set-distribution-parser.js) — sepet ile BİREBİR aynı sonuç ===
    // Ham açıklama + GERÇEK bedenlerle parse; "1XL" gibi belirsizlikler bedenlere göre çözülür.
    var canon = (typeof window !== 'undefined' && window.ToserofSetParser && window.ToserofSetParser.parse)
      ? window.ToserofSetParser.parse(info.productDescription, availableSizes, info.productTitle)
      : null;

    if (canon && canon.found && canon.type === 'beden_seti') {
      isBedenSetiFormat = true;
      variantDistributions = canon.distributions || {};
      log('Beden Seti (canonical):', variantDistributions);
    } else if (canon && canon.found && canon.type === 'std') {
      isBedenSetiFormat = false;
      isPaketYapisiFormat = false;
      sizeDistribution = { STD: canon.multiplier };
      log('STD (canonical):', sizeDistribution);
    } else if (canon && canon.found && canon.type === 'multi_size_set') {
      isBedenSetiFormat = false;
      isPaketYapisiFormat = false;
      sizeDistribution = canon.distribution || {};
      // COMPOUND PAKET: tek compound size variant ama dağılım çok-anahtarlı → STD-total'e collapse
      var ckc = Object.keys(sizeDistribution).length;
      if (ckc > 1 && availableSizes.length === 1) {
        var cps = Object.values(sizeDistribution).reduce(function (s, q) { return s + q; }, 0);
        log('Compound paket (canonical): collapsing to STD-' + cps);
        sizeDistribution = { STD: cps };
      }
      log('Multi-size (canonical):', sizeDistribution);
    } else {
      // FALLBACK — canonical parser yüklenemedi/parse edemedi: eski davranış (geri uyumluluk)
      if (info.isBedenSetiFormat && info.setDistribution &&
        (info.setDistribution.includes('|') || info.setDistribution.includes(','))) {
        isBedenSetiFormat = true;
        variantDistributions = parseVariantDistributions(info.setDistribution);
        log('Beden Seti format detected (fallback)');
      } else {
        isBedenSetiFormat = false;
        isPaketYapisiFormat = false;
        sizeDistribution = parseSetDistribution(info.setDistribution || 'AUTO');
        sizeDistribution = expandCompoundDistribution(sizeDistribution, availableSizes);
        const distKeyCount = Object.keys(sizeDistribution).length;
        if (distKeyCount > 1 && availableSizes.length === 1) {
          const totalPerSet = Object.values(sizeDistribution).reduce((s, q) => s + q, 0);
          sizeDistribution = { STD: totalPerSet };
        }
        log('Traditional format detected (fallback)');
      }
    }

    if (isBedenSetiFormat) {
      if (Object.keys(variantDistributions).length === 0) {
        logError('Could not parse variant distributions');
        return false;
      }
    } else {
      if (Object.keys(sizeDistribution).length === 0) {
        logError('Could not parse size distribution');
        return false;
      }
    }

    log('Set Multiplier initialized successfully');

    moveSetInfoToCorrectPosition();
    updateSetInfoDisplay();
    hideSetMarkersInDescription();
    injectSetQuantityLabel();
    injectSetTotalPrice();

    return true;
  }

  // Shopify product.price = BİRİM fiyat. Toptancı için kritik olan ek bilgi: "set toplamı".
  // Tema zaten birim fiyatı gösteriyor (ör. ₺1,440). Plugin ekstra olarak "Set toplam ₺7,200 (5 adet)" basıyor.
  function injectSetTotalPrice() {
    if (document.querySelector('.set-multiplier-per-unit-price')) return;

    // Set başına kaç adet?
    let perSet = 0;
    if (isBedenSetiFormat) {
      const vals = Object.values(variantDistributions);
      perSet = vals.length > 0 ? Math.max(...vals) : 0;
    } else {
      perSet = Object.values(sizeDistribution).reduce((s, q) => s + q, 0);
    }
    if (perSet < 2) return;

    // Birim fiyat (tema'nın gösterdiği fiyat — product.price) DOM'dan parse et
    const priceSelectors = [
      'sale-price', '.price-list sale-price', 'compare-at-price + sale-price',
      '.price:not(.price--sold-out)', '.product__price', '.product-form__price',
      '.price-item--regular', '.price-item:not(.price-item--compare)'
    ];
    let priceEl = null;
    for (const sel of priceSelectors) {
      const els = document.querySelectorAll(sel);
      for (const el of els) {
        const rect = el.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0 && el.textContent.match(/\d/)) {
          priceEl = el;
          break;
        }
      }
      if (priceEl) break;
    }
    if (!priceEl) return;

    // Fiyatı parse et (TR locale "1.728,90" / EN "1,728.90")
    const priceText = priceEl.textContent.trim();
    const numericPart = priceText.match(/[\d.,]+/);
    if (!numericPart) return;
    let cleanPrice = numericPart[0];
    if (cleanPrice.includes(',') && cleanPrice.includes('.')) {
      const lastComma = cleanPrice.lastIndexOf(',');
      const lastDot = cleanPrice.lastIndexOf('.');
      if (lastComma > lastDot) {
        cleanPrice = cleanPrice.replace(/\./g, '').replace(',', '.');
      } else {
        cleanPrice = cleanPrice.replace(/,/g, '');
      }
    } else if (cleanPrice.includes(',')) {
      cleanPrice = cleanPrice.replace(',', '.');
    }
    const unitPrice = parseFloat(cleanPrice);
    if (!unitPrice || unitPrice <= 0) return;

    // Set toplam = birim × set boyutu (ÇARP, BÖL DEĞİL)
    const setTotal = unitPrice * perSet;
    let formatted;
    try {
      formatted = setTotal.toLocaleString('tr-TR', {
        style: 'currency', currency: 'TRY', minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    } catch (e) {
      formatted = setTotal.toFixed(2) + ' ₺';
    }

    const el = document.createElement('div');
    el.className = 'set-multiplier-per-unit-price';
    el.innerHTML = `Set toplamı <strong>${formatted}</strong> <span class="set-multiplier-per-unit-price__hint">(${perSet} adet × birim fiyat)</span>`;
    priceEl.parentNode.insertBefore(el, priceEl.nextSibling);
    log('Set total price injected:', formatted, '=', unitPrice, '×', perSet);
  }

  // Adet input'unun üstüne "Set sayısı" etiketi yerleştir — toptan müşterisine bu sayının "set" olduğunu net göster
  function injectSetQuantityLabel() {
    const qs = document.querySelector('quantity-selector');
    if (!qs || qs.dataset.setLabeled === 'true') return;
    qs.dataset.setLabeled = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'set-multiplier-qty-label';

    const labelText = document.createElement('span');
    labelText.className = 'set-multiplier-qty-label__text';
    labelText.textContent = 'Set sayısı';

    const liveTotal = document.createElement('span');
    liveTotal.className = 'set-multiplier-qty-label__total';
    liveTotal.id = 'setMultiplierLiveTotal';
    liveTotal.setAttribute('aria-live', 'polite');

    wrapper.appendChild(labelText);
    wrapper.appendChild(liveTotal);
    qs.parentNode.insertBefore(wrapper, qs);
  }

  // Adet input'unun yanındaki canlı toplam metnini güncelle ("→ 5 adet" gibi)
  function updateLiveTotalLabel(setCount) {
    const el = document.getElementById('setMultiplierLiveTotal');
    if (!el) return;
    let perSet = 0;
    if (isBedenSetiFormat) {
      const selectedVariant = getSelectedVariant();
      const variantSize = selectedVariant ? getVariantSize(selectedVariant) : null;
      for (const [range, mul] of Object.entries(variantDistributions)) {
        if (variantSize && isSizeInRange(variantSize, range)) { perSet = mul; break; }
      }
    } else {
      perSet = Object.values(sizeDistribution).reduce((s, q) => s + q, 0);
    }
    const total = (setCount || 1) * perSet;
    el.textContent = total > 0 ? `→ ${total} adet` : '';
  }

  // Description gövdesinde "Set İçerik Bilgisi: 1S-1M-1L-1XL" gibi raw set metnini gizle.
  // Plugin bilgi kutusu zaten kullanıcıya yorumlanmış sürümü gösteriyor; raw teknik metnin müşteriye sızması istenmiyor.
  function hideSetMarkersInDescription() {
    const containerSelectors = [
      '.product__description',
      '.product-description',
      '.product-info__block-item[data-block-type="description"]',
      '.product-content-below-gallery__description',
      '.prose'
    ];

    const markerRegex = /(?:<strong>|<b>)?\s*(?:Set\s+İçerik\s+Bilgisi|Set\s+Icerik\s+Bilgisi|Beden\s+Seti|Dağılım|Paket\s+Yapısı)\s*:\s*(?:<\/strong>|<\/b>)?\s*[^<\n]{0,120}/gi;

    const cleaned = new WeakSet();
    document.querySelectorAll(containerSelectors.join(',')).forEach(el => {
      if (cleaned.has(el)) return;
      cleaned.add(el);
      const before = el.innerHTML;
      const after = before.replace(markerRegex, '');
      if (after !== before) {
        el.innerHTML = after;
        log('Cleaned set markers from description container');
      }
    });
  }

  // Compound distribution key expansion.
  // Distribution {S-M: 3, L-XL: 3} ve gerçek variant'lar [S, M, L, XL] ise → {S: 3, M: 3, L: 3, XL: 3}.
  // Eğer compound key (örn. "S-M") availableSizes'ta TAM eşleşme olarak varsa (compound variant), olduğu gibi koru.
  // Sadece gerçek variant'lar tek-tek olduğunda expansion uygula.
  function expandCompoundDistribution(distribution, availableSizes) {
    if (!distribution || Object.keys(distribution).length === 0) return distribution;
    const availUpper = (availableSizes || []).map(s => String(s).toUpperCase().trim());
    const expanded = {};

    for (const [key, qty] of Object.entries(distribution)) {
      const keyUpper = String(key).toUpperCase().trim();
      // Tireli compound key + availableSizes'ta direkt yok → segment expansion dene
      if (keyUpper.includes('-') && !availUpper.includes(keyUpper)) {
        const parts = keyUpper.split('-').map(s => s.trim()).filter(Boolean);
        // Tüm segmentler gerçek variant'larda var mı?
        const allMatch = parts.length > 0 && parts.every(p => availUpper.includes(p));
        if (allMatch) {
          for (const part of parts) {
            expanded[part] = (expanded[part] || 0) + qty;
          }
          log(`Expanded compound key "${key}" → ${parts.join(',')} (each qty=${qty})`);
          continue;
        }
      }
      // Tireli ama variant compound olarak var, ya da düz key — olduğu gibi kopyala
      expanded[key] = (expanded[key] || 0) + qty;
    }
    return expanded;
  }

  function parseVariantStocks(stockString) {
    if (!stockString) return;

    const stockPairs = stockString.split(',');
    stockPairs.forEach(pair => {
      const parts = pair.split(':');
      if (parts.length === 2) {
        const variantId = parts[0];
        // Format: "stock|size|color" (color opsiyonel — eski format ile geri uyumlu)
        const stockSizeColor = parts[1].split('|');
        if (stockSizeColor.length >= 2) {
          const stock = parseInt(stockSizeColor[0]) || 0;
          const sizeName = stockSizeColor[1];
          const colorName = stockSizeColor[2] || '';
          sizeVariantStocks[variantId] = { stock, sizeName, colorName };
        }
      }
    });
  }

  // Kullanıcının seçtiği variant'ın rengini döndür (sizeVariantStocks'ta cached). Yoksa boş string.
  function getSelectedVariantColor() {
    const selectedId = getSelectedVariant();
    if (!selectedId) return '';
    const info = sizeVariantStocks[selectedId];
    return info ? (info.colorName || '') : '';
  }

  // Optimize edilmiş string temizleme helper fonksiyonu
  function cleanupDistributionText(text) {
    if (!text) return '';
    return text.toString()
      .replace(/<[^>]*>/g, '')
      .replace(/&[a-zA-Z0-9#]+;/g, '')
      .replace(/\*+/g, '')
      .replace(/[\r\n\t\f\v]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Beden ismi geçerli mi? Compound (S-M, 2XL-3XL), slash (M/L), numeric (44, 7-8), extended (1XL..7XL), basic harf (S..XXXL)
  const EXCLUDED_WORDS = new Set(['TRY', 'USD', 'EUR', 'GBP', 'ADET', 'KG', 'TL', 'MAL', 'VE', 'BR', 'DIV', 'EM', 'TEK', 'STD']);
  const VALID_SIZES = new Set(['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XS']);
  const EXTENDED_SIZES = new Set(['1XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL']);

  function isValidSize(size) {
    if (!size) return false;
    // Parantez temizliği: "(140-146)" → "140-146", "(LXL-SM)" → "LXL-SM"
    size = size.toUpperCase().replace(/[()]/g, '').trim();
    if (!size) return false;
    if (EXCLUDED_WORDS.has(size)) return false;
    if (VALID_SIZES.has(size) || EXTENDED_SIZES.has(size)) return true;
    // Sayısal beden (giysi 18-58, ayakkabı 100-200 yaklaşık)
    if (/^\d{2,3}$/.test(size)) {
      const n = parseInt(size);
      return n >= 18 && n <= 200;
    }
    // Tireli compound: S-M, L-XL, 2XL-3XL, 24-25, 7-8
    if (size.includes('-')) {
      const parts = size.split('-');
      return parts.length === 2 && parts[0] && parts[1] && isValidSize(parts[0]) && isValidSize(parts[1]);
    }
    // Slash compound: M/L, S/M, XS/S
    if (size.includes('/')) {
      const parts = size.split('/');
      return parts.length === 2 && parts[0] && parts[1] && isValidSize(parts[0]) && isValidSize(parts[1]);
    }
    return false;
  }

  // Tek token'ı parse et ve dist'e ekle. Başarılıysa true döner.
  function parseToken(token, dist) {
    if (!token) return false;

    // 1. Parantezli: "(S-M)-3" veya "(S-M):3"
    let m = token.match(/^\(([\w/-]+)\)\s*[-:=]\s*(\d{1,3})$/);
    if (m) {
      const size = m[1].toUpperCase();
      const qty = parseInt(m[2]);
      if (qty > 0 && qty <= 100 && isValidSize(size)) {
        dist[size] = qty;
        return true;
      }
    }

    // 2. size[-:]qty — en yaygın: "S-2", "S:1", "M/L:1", "S-M-2", "2XL-3XL-2", "7-8-1", "44-1"
    //    Son '-' veya ':' işaretinden sonrasını adet say, kalanı beden adı.
    m = token.match(/^(.+?)\s*[-:=]\s*(\d{1,3})$/);
    if (m) {
      const size = m[1].replace(/[()]/g, '').toUpperCase().trim();
      const qty = parseInt(m[2]);
      if (qty > 0 && qty <= 100 && isValidSize(size)) {
        dist[size] = qty;
        return true;
      }
    }

    // 3. qty+size bitişik: "2S", "3M", "1XL" — ama "1XL" extended beden tek başına 1 adet anlamı
    m = token.match(/^(\d+)([A-Z]+)$/i);
    if (m) {
      const qty = parseInt(m[1]);
      const sizeBase = m[2].toUpperCase();
      // "1XL" gibi extended beden için: token "1XL" ise size=1XL qty=1 değil; size=1XL qty=undefined.
      // Ama "2S" ise size=S qty=2.
      if (EXTENDED_SIZES.has(qty + sizeBase) && isValidSize(qty + sizeBase)) {
        // 1XL, 2XL, 3XL... gibi — bu extended beden, qty=1 say
        dist[qty + sizeBase] = 1;
        return true;
      }
      if (qty > 0 && qty <= 100 && isValidSize(sizeBase) && VALID_SIZES.has(sizeBase)) {
        dist[sizeBase] = qty;
        return true;
      }
    }

    // 4. size+qty bitişik: "S1", "M2", "XL3"
    m = token.match(/^([A-Z]+)(\d{1,2})$/i);
    if (m) {
      const size = m[1].toUpperCase();
      const qty = parseInt(m[2]);
      if (qty > 0 && qty <= 100 && VALID_SIZES.has(size)) {
        dist[size] = qty;
        return true;
      }
    }

    // 5. Tek başına numeric beden ("36", "38" — Paket Yapısı: 36+38+40+42 normalize edildikten sonra)
    m = token.match(/^(\d{2,3})$/);
    if (m) {
      const size = m[1];
      if (isValidSize(size)) {
        dist[size] = 1;
        return true;
      }
    }

    // 6. Tek başına harf beden ("S", "M", "L" — adet yok = 1)
    m = token.match(/^([A-Z]+)$/i);
    if (m) {
      const size = m[1].toUpperCase();
      if (VALID_SIZES.has(size) || EXTENDED_SIZES.has(size)) {
        dist[size] = 1;
        return true;
      }
    }

    return false;
  }

  // Tek tokende çoklu beden: "1S-1M-1L-1XL", "2S-2M-2L", "S1-M1-L1", "1XL1-2XL1"
  function parseAttachedMultiSizes(text, dist) {
    let found = false;

    // qty"x"size — "1x38-1x40-1x42" veya "2xS-2xM-2xL"
    // KRİTİK: "x" sadece lowercase olarak match etsin — yoksa "1XL"deki "X" çarpan sanılıyor (1S-1M-1L-1XL → dist={L:1} bug'ı).
    let matches = [...text.matchAll(/(\d+)\s*x\s*(\d{2,3}|[A-Za-z]{1,4})(?=[-\s,]|$)/g)];
    for (const m of matches) {
      const qty = parseInt(m[1]);
      const size = m[2].toUpperCase();
      if (qty > 0 && qty <= 100 && isValidSize(size)) {
        dist[size] = qty;
        found = true;
      }
    }
    if (found) return;

    // qty + extended-size + qty: "1XL1-2XL1-3XL1"
    matches = [...text.matchAll(/(\d[A-Z]{1,3})(\d{1,2})(?=[-\s,]|$)/gi)];
    for (const m of matches) {
      const size = m[1].toUpperCase();
      const qty = parseInt(m[2]);
      if (EXTENDED_SIZES.has(size) && qty > 0 && qty <= 100) {
        dist[size] = qty;
        found = true;
      }
    }
    if (found) return;

    // qty + harf-beden: "1S-1M-1L-1XL", "2S2M2L"
    matches = [...text.matchAll(/(\d+)([A-Z]{1,4})(?=[-\s,]|$)/gi)];
    for (const m of matches) {
      const qty = parseInt(m[1]);
      const size = m[2].toUpperCase();
      if (VALID_SIZES.has(size) && qty > 0 && qty <= 100) {
        dist[size] = qty;
        found = true;
      }
    }
    if (found) return;

    // harf-beden + qty bitişik: "S1-M1-L1-XL1"
    matches = [...text.matchAll(/([A-Z]{1,4})(\d{1,2})(?=[-\s,]|$)/gi)];
    for (const m of matches) {
      const size = m[1].toUpperCase();
      const qty = parseInt(m[2]);
      if (VALID_SIZES.has(size) && qty > 0 && qty <= 100) {
        dist[size] = qty;
        found = true;
      }
    }
    if (found) return;

    // Sadece extended-size isimleri (adet yok): "1XL-2XL-3XL" → her birinden 1
    matches = [...text.matchAll(/(\d[A-Z]{1,3})(?=[-\s,]|$)/gi)];
    for (const m of matches) {
      const size = m[1].toUpperCase();
      if (EXTENDED_SIZES.has(size)) {
        dist[size] = 1;
      }
    }
  }

  function parseSetDistribution(distributionText) {
    if (!distributionText) return {};

    const cleanText = cleanupDistributionText(distributionText);
    log('Parsing distribution text:', cleanText);

    // 1. STD-N, STD:N veya STDN (bitişik) — STD'den hemen sonra rakam (ayraç opsiyonel)
    let m = cleanText.match(/\bSTD\s*[-:]?\s*(\d+)/i);
    if (m) {
      const n = parseInt(m[1]);
      if (n > 0 && n < 100) {
        log('STD format:', n);
        return { STD: n };
      }
    }

    // 2. NxSTANDART veya NxSTD
    m = cleanText.match(/(\d+)\s*x\s*(?:STANDART|STD)\b/i);
    if (m) {
      const n = parseInt(m[1]);
      if (n > 0 && n < 100) {
        log('xSTANDART format:', n);
        return { STD: n };
      }
    }

    // 3. N STANDART veya STANDART N — ama "STANDART KALIP" / "STANDART KESIM" gibi false-positive'leri dışla
    //    Sayı/STANDART arasında başka kelime varsa (KALIP, KESIM, BEDEN vb.) match etmesin
    m = cleanText.match(/(\d+)\s+STANDART(?!\s*(?:KALIP|KESIM|BEDEN|KESİM|EBAT))/i);
    if (!m) {
      m = cleanText.match(/STANDART\s+(\d+)\b/i);
    }
    if (m) {
      const n = parseInt(m[1]);
      if (n > 0 && n < 100) {
        log('STANDART number format:', n);
        return { STD: n };
      }
    }

    // 4. ONE SIZE / TEK BEDEN
    if (/\bONE\s*SIZE\b/i.test(cleanText) || /\bTEK\s*BEDEN\b/i.test(cleanText)) {
      log('ONE SIZE format');
      return { STD: 1 };
    }

    // 5. Token-based parsing — boşluk veya virgülle böl, her token'ı ayrı ayrı parse et
    //    Ayrıca " - " ayırıcılarını da temizle (Dağılım: S:1 - M:1 gibi)
    const distribution = {};
    const tokens = cleanText
      .split(/[\s,]+/)
      .map(t => t.trim())
      .filter(t => t && !/^[-:=]+$/.test(t));

    for (const token of tokens) {
      parseToken(token, distribution);
    }

    if (Object.keys(distribution).length > 0) {
      log('Token-based distribution:', distribution);
      return distribution;
    }

    // 6. Tek token (boşluksuz) — bitişik multi-size: "1S-1M-1L-1XL", "2S2M2L", "S1-M1-L1"
    if (tokens.length >= 1) {
      for (const token of tokens) {
        parseAttachedMultiSizes(token, distribution);
        if (Object.keys(distribution).length > 0) break;
      }
    }

    if (Object.keys(distribution).length > 0) {
      log('Attached multi-size distribution:', distribution);
      return distribution;
    }

    // 7. AUTO mode — variant beden listesinden her birinden 1
    if (availableSizes.length > 0) {
      log('No distribution parsed, using AUTO mode');
      for (const size of availableSizes) {
        const normalizedSize = size.toUpperCase();
        if (isValidSize(normalizedSize)) {
          distribution[normalizedSize] = 1;
        }
      }
    }

    log('Final distribution:', distribution);
    return distribution;
  }

  function parseVariantDistributions(distributionText) {
    const distributions = {};

    if (!distributionText) return distributions;

    const pairs = distributionText.split(',');

    pairs.forEach(pair => {
      const parts = pair.split('|');
      if (parts.length === 2) {
        const range = parts[0].trim();
        const multiplier = parseInt(parts[1]) || 1;
        distributions[range] = multiplier;
      }
    });

    return distributions;
  }
  function parsePaketYapisi(distributionText) {
    if (!distributionText) return 1;

    const cleanText = cleanupDistributionText(distributionText);
    log('Parsing Paket Yapısı text:', cleanText);

  // "Paket Yapısı: 1S+1M+1L+1XL" formatını parse et
  const paketMatch = cleanText.match(/Paket Yapısı:\s*(.+)/i);
  if (paketMatch) {
    const paketContent = paketMatch[1];
    // '+' ile ayrılmış kısımları say
    const parts = paketContent.split('+');
    const multiplier = parts.length;
    log(`Paket Yapısı detected: ${paketContent} -> multiplier: ${multiplier}`);
    return multiplier;
  }

  return 1;
}
  // STD format için özel stok kontrolü
  function calculateMaxSetsForSTD(stdMultiplier) {
    // STD formatında tek beden var ama çoklu renk varyantı olabilir — kullanıcının seçtiği variant'ı tercih et
    if (allSizeVariants.length === 0) {
      return {
        maxSets: 0,
        limitingFactor: 'Variant bulunamadı',
        stockDetails: {},
        missingVariants: []
      };
    }

    const selectedId = getSelectedVariant();
    const variantId = (selectedId && sizeVariantStocks[selectedId]) ? selectedId : allSizeVariants[0];
    const stockInfo = sizeVariantStocks[variantId];

    if (!stockInfo) {
      return {
        maxSets: 0,
        limitingFactor: 'Stok bilgisi bulunamadı',
        stockDetails: {},
        missingVariants: []
      };
    }

    const availableStock = stockInfo.stock || 0;
    const maxSets = Math.floor(availableStock / stdMultiplier);

    log(`STD Stock Check: ${availableStock} stok / ${stdMultiplier} multiplier = ${maxSets} maksimum set`);

    return {
      maxSets: maxSets,
      limitingFactor: `${availableStock} stok / ${stdMultiplier} multiplier`,
      stockDetails: {
        'STD': {
          required: stdMultiplier,
          available: availableStock,
          variantId: variantId
        }
      },
      missingVariants: []
    };
  }

  // Darboğaz stok kontrolü fonksiyonu
  function calculateMaxSetsFromStock(distribution) {
    const isSTDFormat = Object.keys(distribution).length === 1 && Object.keys(distribution)[0] === 'STD';

    if (isSTDFormat) {
      const stdMultiplier = distribution['STD'];
      return calculateMaxSetsForSTD(stdMultiplier);
    }

    let maxSets = Infinity;
    const stockDetails = {};

    for (const [size, requiredQty] of Object.entries(distribution)) {
      const variantId = findVariantIdBySize(size);

      if (!variantId) {
        log(`Variant not found for size: ${size}`);
        return {
          maxSets: 0,
          limitingFactor: `${size} bedeni bulunamadı`,
          stockDetails: {},
          missingVariants: [size]
        };
      }

      const stockInfo = sizeVariantStocks[variantId];
      const availableStock = stockInfo ? stockInfo.stock : 0;

      stockDetails[size] = {
        required: requiredQty,
        available: availableStock,
        variantId: variantId
      };

      const possibleSets = Math.floor(availableStock / requiredQty);

      if (possibleSets < maxSets) {
        maxSets = possibleSets;
      }

      log(`Size ${size}: ${availableStock} stok / ${requiredQty} gerekli = ${possibleSets} set`);
    }

    const limitingSize = Object.entries(stockDetails).find(([size, info]) =>
      Math.floor(info.available / info.required) === maxSets
    );

    return {
      maxSets: maxSets === Infinity ? 0 : maxSets,
      limitingFactor: limitingSize ? `${limitingSize[0]} bedeni (${limitingSize[1].available} stok)` : 'Bilinmeyen',
      stockDetails: stockDetails,
      missingVariants: []
    };
  }

  // Eksik varyant kontrolü
  function checkMissingVariants(distribution) {
    const missingVariants = [];

    for (const size of Object.keys(distribution)) {
      const variantId = findVariantIdBySize(size);
      if (!variantId) {
        missingVariants.push(size);
      }
    }

    return missingVariants;
  }

  // Set bütünlüğü kontrolü
  function validateSetIntegrity(userQuantity, distribution) {
    const stockAnalysis = calculateMaxSetsFromStock(distribution);
    const missingVariants = checkMissingVariants(distribution);

    const result = {
      isValid: true,
      maxPossibleSets: stockAnalysis.maxSets,
      requestedSets: userQuantity,
      canFulfill: userQuantity <= stockAnalysis.maxSets,
      missingVariants: missingVariants,
      limitingFactor: stockAnalysis.limitingFactor,
      stockDetails: stockAnalysis.stockDetails,
      errors: []
    };

    // Eksik varyant kontrolü
    if (missingVariants.length > 0) {
      result.isValid = false;
      result.errors.push(`Eksik bedenler: ${missingVariants.join(', ')}`);
    }

    // Stok yetersizliği kontrolü
    if (userQuantity > stockAnalysis.maxSets) {
      result.isValid = false;
      result.errors.push(`Stok yetersiz. Maksimum ${stockAnalysis.maxSets} set eklenebilir. Sınırlayıcı: ${stockAnalysis.limitingFactor}`);
    }

    log('Set Integrity Check:', result);
    return result;
  }

  // Quantity input'ları maksimum değerle sınırla
  function limitQuantityInputs() {
    if (isBedenSetiFormat) {
      // Beden seti formatında variant bazlı sınırlama
      const selectedVariant = getSelectedVariant();
      if (selectedVariant) {
        const variantSize = getVariantSize(selectedVariant);
        let multiplier = 1;
        let matched = false;

        for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
          if (isSizeInRange(variantSize, range)) {
            multiplier = rangeMultiplier;
            matched = true;
            break;
          }
        }

        // Fallback: variant range distribution'da yoksa ilk multiplier'ı kullan (compound paketler için)
        if (!matched) {
          const ranges = Object.values(variantDistributions);
          if (ranges.length > 0) multiplier = ranges[0];
        }

        const stockInfo = sizeVariantStocks[selectedVariant];
        const maxSets = stockInfo ? Math.floor(stockInfo.stock / multiplier) : 0;

        setQuantityInputLimits(maxSets);
      }
    }
    else if (isPaketYapisiFormat) {
      // Paket formatında tek variant var, ilk variant'ı kullan
      if (allSizeVariants.length > 0) {
        const variantId = allSizeVariants[0];
        const stockInfo = sizeVariantStocks[variantId];
        const maxSets = stockInfo ? Math.floor(stockInfo.stock / paketMultiplier) : 0;
        setQuantityInputLimits(maxSets);
      }
    }
   else {
  // Traditional format için set bazlı sınırlama
  const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

  if (isSTDFormat) {
    const stdMultiplier = sizeDistribution['STD'];
    log(`STD Format detected: multiplier = ${stdMultiplier}`);

    // STD için özel stok kontrolü
    const stockAnalysis = calculateMaxSetsForSTD(stdMultiplier);
    const maxSets = stockAnalysis.maxSets;

    log(`STD Max sets calculation: ${maxSets} sets allowed`);
    setQuantityInputLimits(maxSets);
  } else {
    const stockAnalysis = calculateMaxSetsFromStock(sizeDistribution);
    setQuantityInputLimits(stockAnalysis.maxSets);
  }
}
  }

  function setQuantityInputLimits(maxValue) {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[type="number"][name="quantity"]',
      '.quantity-selector input',
      '.quantity__input',
      '.qty',
      '[data-quantity-input]'
    ];

    quantitySelectors.forEach(selector => {
      const inputs = document.querySelectorAll(selector);
      inputs.forEach(input => {
        if (input.type === 'number' || input.type === 'text') {
          input.setAttribute('max', maxValue);

          // Mevcut değer maksimumdan büyükse düzelt
          const currentValue = parseInt(input.value) || 1;
          if (currentValue > maxValue) {
            input.value = Math.max(1, maxValue);

            // Change event'ini tetikle
            const changeEvent = new Event('change', { bubbles: true });
            input.dispatchEvent(changeEvent);
          }

          // SERT ENGELLİ: Input'a manuel yazımı engelle
          if (maxValue === 0) {
            input.value = 0;
            input.disabled = true;
            input.style.backgroundColor = '#f5f5f5';
            input.style.color = '#999';
          } else {
            // Klavye ve mouse ile artırma/azaltmayı engelle
            input.addEventListener('keydown', function (e) {
              // Arrow up ve Page up tuşlarını engelle
              if ((e.key === 'ArrowUp' || e.key === 'PageUp') && parseInt(this.value) >= maxValue) {
                e.preventDefault();
                showQuantityLimitWarning(maxValue);
                return false;
              }
              // Arrow down sadece 1'den küçük olmasını engelle
              if ((e.key === 'ArrowDown' || e.key === 'PageDown') && parseInt(this.value) <= 1) {
                e.preventDefault();
                return false;
              }
            });

            // Mouse wheel ile artırmayı engelle
            input.addEventListener('wheel', function (e) {
              if (e.deltaY < 0 && parseInt(this.value) >= maxValue) { // Wheel up
                e.preventDefault();
                showQuantityLimitWarning(maxValue);
                return false;
              }
            });

            // Manuel yazım kontrolü
            input.addEventListener('input', function (e) {
              let value = parseInt(this.value);
              if (isNaN(value) || value < 1) {
                this.value = 1;
              } else if (value > maxValue) {
                this.value = maxValue;
                showQuantityLimitWarning(maxValue);
              }
            });
          }
        }
      });
    });

    // Plus/minus butonlarını kontrol et
    updateQuantityButtons(maxValue);

    log(`Quantity inputs limited to maximum: ${maxValue} sets`);
  }

  function updateQuantityButtons(maxValue) {
    const currentQuantity = getCurrentQuantity();

    // Plus butonlarını kontrol et - SERT ENGELLİ
    const plusButtons = document.querySelectorAll(
      '[name="plus"], .quantity__button[name="plus"], button[aria-label*="Increase"], .btn-number[data-type="plus"], .quantity-selector button:last-child'
    );

    plusButtons.forEach(btn => {
      if (currentQuantity >= maxValue || maxValue === 0) {
        btn.disabled = true;
        btn.style.opacity = '0.3';
        btn.style.cursor = 'not-allowed';
        btn.style.pointerEvents = 'none';
        btn.title = `Maksimum ${maxValue} set eklenebilir`;

        // Tüm event listener'ları kaldır
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);

        // Yeni engelleme event'i ekle
        newBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showQuantityLimitWarning(maxValue);
          return false;
        });
      } else {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
        btn.style.pointerEvents = 'auto';
        btn.title = '';
      }
    });

    // Minus butonlarını kontrol et
    const minusButtons = document.querySelectorAll(
      '[name="minus"], .quantity__button[name="minus"], button[aria-label*="Decrease"], .btn-number[data-type="minus"], .quantity-selector button:first-child'
    );

    minusButtons.forEach(btn => {
      if (currentQuantity <= 1 || maxValue === 0) {
        btn.disabled = true;
        btn.style.opacity = '0.3';
        btn.style.cursor = 'not-allowed';
        btn.style.pointerEvents = 'none';
      } else {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
        btn.style.pointerEvents = 'auto';
      }
    });
  }

  // Sınır uyarısı göster
  function showQuantityLimitWarning(maxValue) {
  // Mevcut uyarıyı kaldır
  const existingWarning = document.querySelector('.quantity-limit-warning');
  if (existingWarning) {
    existingWarning.remove();
  }

  const warning = document.createElement('div');
  warning.className = 'quantity-limit-warning';

  const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';
  let message;

  if (maxValue === 0) {
    if (isPaketYapisiFormat) {
      message = 'Stok yetersiz! Bu paket ürün sepete eklenemez.';
    } else if (isSTDFormat) {
      message = 'Stok yetersiz! Bu ürün sepete eklenemez.';
    } else {
      message = 'Set bütünlüğü korunamıyor! Eksik bedenler var.';
    }
  } else {
    let multiplier = 1;
    if (isPaketYapisiFormat) {
      multiplier = paketMultiplier;
    } else if (isSTDFormat) {
      multiplier = sizeDistribution['STD'];
    }
    const totalItems = maxValue * multiplier;
    const formatType = isPaketYapisiFormat ? 'paket' : 'set';
    message = `Maksimum ${maxValue} ${formatType} (${totalItems} adet) eklenebilir!`;
  }

  warning.innerHTML = `
    <span class="quantity-limit-warning__icon" aria-hidden="true">⚠️</span>
    <span class="quantity-limit-warning__message">${escapeHtml(message)}</span>
  `;

  document.body.appendChild(warning);

  // 3 saniye sonra kaldır
  setTimeout(() => {
    if (warning.parentNode) {
      warning.classList.add('quantity-limit-warning--leaving');
      setTimeout(() => warning.remove(), 300);
    }
  }, 3000);
}

  function moveSetInfoToCorrectPosition() {
    const setInfoElement = document.getElementById('setMultiplierInfo');
    if (!setInfoElement) {
      log('Set info element not found, will be created later');
      return;
    }

    const priceSelectors = [
      '.price:not(.price--sold-out)',
      '.product-price',
      '.product__price',
      '.product-form__price',
      '[data-price]',
      '[data-product-price]',
      '.money',
      '.price-item',
      '.price-wrapper',
      '.product-price-wrapper'
    ];

    let priceElement = null;

    for (const selector of priceSelectors) {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        priceElement = Array.from(elements).find(el => {
          const rect = el.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        });
        if (priceElement) {
          log(`Found price element with selector: ${selector}`);
          break;
        }
      }
    }

    if (!priceElement) {
      const productForm = document.querySelector('form[action*="/cart/add"], .product-form');
      if (productForm) {
        priceElement = productForm.querySelector('.price, [class*="price"]');
        if (priceElement) {
          log('Found price element in product form');
        }
      }
    }

    if (priceElement) {
      priceElement.parentNode.insertBefore(setInfoElement, priceElement.nextSibling);
      log('Set info moved to position after price element');
    } else {
      log('Price element not found, keeping set info in original position');
      const productForm = document.querySelector('form[action*="/cart/add"], .product-form');
      if (productForm) {
        productForm.appendChild(setInfoElement);
        log('Set info moved to end of product form');
      }
    }
  }

  function updateSetInfoDisplay() {
    const setInfoText = document.getElementById('setInfoText');
    const setInfoDetails = document.getElementById('setInfoDetails');

    if (!setInfoText || !setInfoDetails) return;

    if (isBedenSetiFormat) {
      setInfoText.innerHTML = '<strong>Beden Seti:</strong> Seçtiğiniz bedene göre otomatik olarak farklı miktarlarda ürün sepetinize eklenecektir.';

      let detailsHtml = '<ul class="set-multiplier-info__rows">';
      for (const [range, multiplier] of Object.entries(variantDistributions)) {
        detailsHtml += `<li class="set-multiplier-info__row"><span class="set-multiplier-info__range">${escapeHtml(range)}</span> seçerseniz → <strong>${multiplier} adet</strong> ürün eklenecek</li>`;
      }
      detailsHtml += '</ul>';
      setInfoDetails.innerHTML = detailsHtml;
    }
    else {
      const totalItems = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);
      const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

      if (isSTDFormat) {
        setInfoText.innerHTML = `<strong>Set Ürün:</strong> Her 1 adet sipariş için ${totalItems} adet ürün sepetinize eklenecektir.`;
        setInfoDetails.innerHTML = '<p class="set-multiplier-info__hint">Bu ürün set halinde satılmaktadır.</p>';
      } else {
        const stockAnalysis = calculateMaxSetsFromStock(sizeDistribution);

        setInfoText.innerHTML = `<strong>Set Ürün:</strong> Her 1 adet için ${totalItems} farklı beden ürünü sepetinize eklenecektir.`;

        const distributionParts = [];
        for (const [size, qty] of Object.entries(sizeDistribution)) {
          distributionParts.push(`${escapeHtml(size)} (${qty} adet)`);
        }

        let detailsHtml = `<p class="set-multiplier-info__distribution"><strong>Dağılım:</strong> ${distributionParts.join(', ')}</p>`;
        detailsHtml += `<div class="set-multiplier-info__max">
          <strong>Maksimum Eklenebilir:</strong> ${stockAnalysis.maxSets} set
          ${stockAnalysis.maxSets > 0 ? `<span class="set-multiplier-info__max-hint">Sınırlayıcı: ${escapeHtml(stockAnalysis.limitingFactor)}</span>` : ''}
        </div>`;

        setInfoDetails.innerHTML = detailsHtml;
      }
    }
  }

  // XSS koruması: dinamik içerikleri HTML'e basarken escape et
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function getCurrentQuantity() {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[type="number"][name="quantity"]',
      '.quantity-selector input',
      '.quantity__input',
      '.qty',
      '[data-quantity-input]'
    ];

    for (const selector of quantitySelectors) {
      const input = document.querySelector(selector);
      if (input && input.value) {
        const value = parseInt(input.value) || 1;
        log(`Found quantity input: ${selector} = ${value}`);
        return Math.max(1, value);
      }
    }

    log('No quantity input found, defaulting to 1');
    return 1;
  }

  function updateSetInfoOnQuantityChange(quantity) {
    const setInfoDetails = document.getElementById('setInfoDetails');
    if (!setInfoDetails) return;

    quantity = Math.max(1, parseInt(quantity) || 1);

    // Maksimum sınırları kontrol et ve güncelle
    limitQuantityInputs();

    // "Set sayısı → X adet" canlı etiketini güncelle
    updateLiveTotalLabel(quantity);

    if (isBedenSetiFormat) {
      const selectedVariant = getSelectedVariant();
      if (selectedVariant) {
        const variantSize = getVariantSize(selectedVariant);
        let selectedRange = null;
        let multiplier = 1;

        for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
          if (isSizeInRange(variantSize, range)) {
            selectedRange = range;
            multiplier = rangeMultiplier;
            break;
          }
        }

        // Fallback: variant range distribution'da yoksa ilk range'in multiplier'ını kullan
        if (!selectedRange) {
          const ranges = Object.entries(variantDistributions);
          if (ranges.length > 0) {
            selectedRange = String(variantSize).replace(/[()]/g, '').trim() || ranges[0][0];
            multiplier = ranges[0][1];
          }
        }

        if (selectedRange) {
          const finalQuantity = quantity * multiplier;
          const stockInfo = sizeVariantStocks[selectedVariant];
          const maxSets = stockInfo ? Math.floor(stockInfo.stock / multiplier) : 0;

          setInfoDetails.innerHTML = `
            <div class="set-multiplier-info__selection">
              <div class="set-multiplier-info__selection-line">
                <strong>Seçiminiz:</strong> ${escapeHtml(selectedRange)} → ${quantity} × ${multiplier} =
                <span class="set-multiplier-info__selection-total">${finalQuantity} adet</span> sepete eklenecek
              </div>
              <div class="set-multiplier-info__selection-max">Maksimum eklenebilir: ${maxSets} set (${maxSets * multiplier} adet)</div>
            </div>`;
        }
      }
    }
    else {
      const totalPerSet = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);
      const finalTotal = quantity * totalPerSet;
      const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

      if (isSTDFormat) {
        const stdQuantity = sizeDistribution['STD'];
        const selectedId = getSelectedVariant();
        const variantId = (selectedId && sizeVariantStocks[selectedId]) ? selectedId : allSizeVariants[0];
        const stockInfo = sizeVariantStocks[variantId];
        const maxSets = stockInfo ? Math.floor(stockInfo.stock / stdQuantity) : 0;

        setInfoDetails.innerHTML = `
          <div class="set-multiplier-info__selection">
            <div class="set-multiplier-info__selection-line">
              <strong>Sepete eklenecek:</strong> ${quantity} adet × ${totalPerSet} =
              <span class="set-multiplier-info__selection-total">${finalTotal} adet</span> ürün
            </div>
            <div class="set-multiplier-info__selection-max">Maksimum eklenebilir: ${maxSets} set (${maxSets * totalPerSet} adet)</div>
          </div>`;
      } else {
        const validation = validateSetIntegrity(quantity, sizeDistribution);
        const boxClass = validation.isValid ? 'set-multiplier-info__selection' : 'set-multiplier-info__selection set-multiplier-info__selection--error';

        if (validation.isValid) {
          const details = [];
          for (const [size, qty] of Object.entries(sizeDistribution)) {
            details.push(`${escapeHtml(size)}: ${qty * quantity} adet`);
          }
          setInfoDetails.innerHTML = `
            <div class="${boxClass}">
              <div class="set-multiplier-info__selection-line">
                <strong>Sepete eklenecek:</strong> ${quantity} set × ${totalPerSet} adet =
                <span class="set-multiplier-info__selection-total">${finalTotal} adet</span>
              </div>
              <div class="set-multiplier-info__selection-detail">Detay: ${details.join(', ')}</div>
              <div class="set-multiplier-info__selection-max">Maksimum eklenebilir: ${validation.maxPossibleSets} set (${validation.maxPossibleSets * totalPerSet} adet)</div>
            </div>`;
        } else {
          let errorList = '';
          validation.errors.forEach(error => {
            errorList += `<li>${escapeHtml(error)}</li>`;
          });
          setInfoDetails.innerHTML = `
            <div class="${boxClass}">
              <div class="set-multiplier-info__selection-line"><strong>⚠ Ekleme Yapılamaz</strong></div>
              <ul class="set-multiplier-info__error-list">${errorList}</ul>
              <div class="set-multiplier-info__selection-max">Maksimum eklenebilir: ${validation.maxPossibleSets} set</div>
            </div>`;
        }
      }
    }
  }

  function getSelectedVariant() {
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      return variantSelect.value;
    }

    const checkedVariant = document.querySelector('input[name="id"]:checked');
    if (checkedVariant) {
      return checkedVariant.value;
    }

    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      return variantInput.value;
    }

    return null;
  }

  function setupQuantityListener() {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[type="number"][name="quantity"]',
      '.quantity-selector input',
      '.quantity__input',
      '.qty',
      '[data-quantity-input]'
    ];

    quantitySelectors.forEach(selector => {
      const inputs = document.querySelectorAll(selector);
      inputs.forEach(input => {
        ['input', 'change', 'keyup', 'blur'].forEach(eventType => {
          input.addEventListener(eventType, (e) => {
            // OPTIMIZE EDİLMİŞ: Debounce ile tekrar eden event'leri engelle
            debounce('quantityChange', () => {
              let quantity = parseInt(e.target.value) || 1;

              // Maximum değeri kontrol et
              const maxValue = parseInt(e.target.getAttribute('max'));
              if (maxValue && quantity > maxValue) {
                quantity = maxValue;
                e.target.value = maxValue;
                showQuantityLimitWarning(maxValue);
              }

              // Minimum 1 olması gerekiyor (max 0 değilse)
              if (quantity < 1 && maxValue !== 0) {
                quantity = 1;
                e.target.value = 1;
              }

              log(`Quantity changed via ${eventType}: ${quantity}`);
              updateSetInfoOnQuantityChange(quantity);
            }, 200);
          });
        });
      });
    });

    const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        const currentQuantity = getCurrentQuantity();
        log(`Variant changed, updating with quantity: ${currentQuantity}`);

        // Variant değiştiğinde sınırları yeniden hesapla
        limitQuantityInputs();
        updateSetInfoOnQuantityChange(currentQuantity);
      });
    });

    // Plus/minus butonları için SERT event listener'lar
    const plusButtons = document.querySelectorAll(
      '[name="plus"], .quantity__button[name="plus"], button[aria-label*="Increase"], .btn-number[data-type="plus"], .quantity-selector button:last-child'
    );

    plusButtons.forEach(btn => {
      // Tüm mevcut event listener'ları kaldır
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const quantityInput = document.querySelector('input[name="quantity"]') ||
          e.target.parentNode.querySelector('input[name="quantity"], input[type="number"]');

        if (quantityInput) {
          const currentValue = parseInt(quantityInput.value) || 1;
          const maxValue = parseInt(quantityInput.getAttribute('max')) || Infinity;

          if (currentValue < maxValue && maxValue > 0) {
            const newValue = currentValue + 1;
            quantityInput.value = newValue;

            const changeEvent = new Event('change', { bubbles: true });
            quantityInput.dispatchEvent(changeEvent);
          } else {
            showQuantityLimitWarning(maxValue);
          }
        }

        return false;
      });
    });

    const minusButtons = document.querySelectorAll(
      '[name="minus"], .quantity__button[name="minus"], button[aria-label*="Decrease"], .btn-number[data-type="minus"], .quantity-selector button:first-child'
    );

    minusButtons.forEach(btn => {
      // Tüm mevcut event listener'ları kaldır
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const quantityInput = document.querySelector('input[name="quantity"]') ||
          e.target.parentNode.querySelector('input[name="quantity"], input[type="number"]');

        if (quantityInput) {
          const currentValue = parseInt(quantityInput.value) || 1;
          const maxValue = parseInt(quantityInput.getAttribute('max')) || Infinity;

          if (currentValue > 1 && maxValue > 0) {
            const newValue = currentValue - 1;
            quantityInput.value = newValue;

            const changeEvent = new Event('change', { bubbles: true });
            quantityInput.dispatchEvent(changeEvent);
          }
        }

        return false;
      });
    });

    const observer = new MutationObserver((mutations) => {
      // OPTIMIZE EDİLMİŞ: Debounce ile tekrarlayan çağrıları engelle
      debounce('mutationObserver', () => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                const quantityInputs = node.querySelectorAll ? node.querySelectorAll(quantitySelectors.join(',')) : [];
                quantityInputs.forEach(input => {
                  ['input', 'change'].forEach(eventType => {
                    input.addEventListener(eventType, (e) => {
                      let quantity = parseInt(e.target.value) || 1;

                      // Maximum değeri kontrol et
                      const maxValue = parseInt(e.target.getAttribute('max'));
                      if (maxValue && quantity > maxValue) {
                        quantity = maxValue;
                        e.target.value = maxValue;
                        showQuantityLimitWarning(maxValue);
                      }

                      updateSetInfoOnQuantityChange(quantity);
                    });
                  });
                });
              }
            });
          }
        });
      }, 500);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Başlangıçta maksimum sınırları uygula
    setTimeout(() => {
      limitQuantityInputs();
    }, 100);
  }

  function normalizeSize(size) {
    return size.toString().toUpperCase().replace(/[()]/g, '').trim();
  }

  // Beden + renk birlikte arar. targetColor verilmişse aynı renkteki variant'ı tercih eder; yoksa kullanıcının seçtiği rengi kullanır.
  // Eğer renk filtresi sonuçsuz kalırsa fallback olarak renksiz aramaya geçer (compound paketler için).
  function findVariantIdBySize(targetSize, targetColor) {
    const normalizedTarget = normalizeSize(targetSize);
    // Renk verilmediyse kullanıcının seçtiği variant'ın rengini al
    if (targetColor === undefined) {
      targetColor = getSelectedVariantColor();
    }
    log(`🔍 Searching for variant with size: "${targetSize}" (normalized: "${normalizedTarget}", color: "${targetColor}")`);

    if (normalizedTarget === 'STD') {
      // STD format: tek beden, ama renk varsa seçili rengin variant'ını kullan
      if (targetColor) {
        for (const variantId in sizeVariantStocks) {
          if ((sizeVariantStocks[variantId].colorName || '') === targetColor) {
            log(`✓ STD with color: variant ${variantId} (color: ${targetColor})`);
            return variantId;
          }
        }
      }
      // Fallback: kullanıcı seçimi yoksa ilk variant
      const selectedId = getSelectedVariant();
      if (selectedId && sizeVariantStocks[selectedId]) {
        log(`✓ STD: using selected variant ${selectedId}`);
        return selectedId;
      }
      if (allSizeVariants.length > 0) {
        log('✓ STD format: Using first available variant:', allSizeVariants[0]);
        return allSizeVariants[0];
      }
    }

    // Renk filtreli tam eşleşme: aynı beden + aynı renk
    if (targetColor) {
      for (const variantId in sizeVariantStocks) {
        const sizeInfo = sizeVariantStocks[variantId];
        if (normalizeSize(sizeInfo.sizeName) === normalizedTarget && (sizeInfo.colorName || '') === targetColor) {
          log(`✓ Found variant ${variantId} for size=${targetSize}, color=${targetColor}`);
          return variantId;
        }
      }
    }

    // Renksiz tam eşleşme (geri uyumlu)
    log('📦 Fallback to size-only search');
    for (const variantId in sizeVariantStocks) {
      const sizeInfo = sizeVariantStocks[variantId];
      if (normalizeSize(sizeInfo.sizeName) === normalizedTarget) {
        log(`✓ Found variant ${variantId} for size ${targetSize} (size-only match, no color filter)`);
        return variantId;
      }
    }

    // availableSizes index'e göre fallback
    for (let i = 0; i < availableSizes.length; i++) {
      const availableSize = normalizeSize(availableSizes[i]);
      if (availableSize === normalizedTarget && i < allSizeVariants.length) {
        return allSizeVariants[i];
      }
    }

    // Kısmi compound match (renk-aware)
    log('🔍 Trying partial match for compound sizes...');
    for (const variantId in sizeVariantStocks) {
      const sizeInfo = sizeVariantStocks[variantId];
      const sizeName = normalizeSize(sizeInfo.sizeName);
      if (sizeName.includes('-')) {
        const sizeParts = sizeName.split('-').map(s => s.trim());
        if (sizeParts.includes(normalizedTarget)) {
          if (!targetColor || (sizeInfo.colorName || '') === targetColor) {
            log(`✓ Compound match variant ${variantId} for ${targetSize}`);
            return variantId;
          }
        }
      }
    }

    logError(`❌ Variant NOT found for size: "${targetSize}" (color: "${targetColor}")`);
    logError('Available variants:', Object.keys(sizeVariantStocks).map(k => `${k}=${sizeVariantStocks[k].sizeName}/${sizeVariantStocks[k].colorName}`));
    return null;
  }

  // CSS animasyonları ekle
  function forceMultiplier() {
    if (isInitialized) return;
    isInitialized = true;

    if (!initializeMultiplier()) {
      logError('Set multiplier initialization failed');
      return;
    }
    // Stiller theme/assets/set-multiplier.css üzerinden yüklenir; inline injection yok.

    // Debug: Başlangıç bilgilerini logla
    log('=== INITIALIZATION DEBUG ===');
    log('Size distribution:', sizeDistribution);
    log('Size variant stocks:', sizeVariantStocks);
    log('All size variants:', allSizeVariants);
    log('Is STD format:', Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD');

    if (Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD') {
      const stdMultiplier = sizeDistribution['STD'];
      const stockAnalysis = calculateMaxSetsForSTD(stdMultiplier);
      log('STD Stock Analysis:', stockAnalysis);
    }
    log('=== END DEBUG ===');

    const originalFetch = window.fetch;
    let interceptorApplied = false;

    if (!interceptorApplied) {
      window.fetch = async function (url, options = {}) {
        if (options.headers && options.headers[internalRequestFlag]) {
          delete options.headers[internalRequestFlag];
          return originalFetch.call(this, url, options);
        }

        if (typeof url === 'string' && url.includes('/cart/add')) {
          return handleSetCartRequest(originalFetch, url, options);
        }

        return originalFetch.call(this, url, options);
      };
      interceptorApplied = true;
      log('Fetch interceptor applied');
    }

    setTimeout(() => {
      setupQuantityListener();
      moveSetInfoToCorrectPosition();
      const initialQuantity = getCurrentQuantity();
      log(`Updating with initial quantity: ${initialQuantity}`);
      updateSetInfoOnQuantityChange(initialQuantity);
    }, 500);

    log('Set Multiplier active');
  }

  // Sepete ekle butonunu bul (tema'nın buy-buttons içindeki submit butonu)
  function findAddToCartButton() {
    const selectors = [
      'buy-buttons button[type="submit"]',
      '.buy-buttons button[type="submit"]',
      'product-form button[type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]',
      'button[name="add"]',
      '[data-add-to-cart]'
    ];
    for (const sel of selectors) {
      const btn = document.querySelector(sel);
      if (btn) return btn;
    }
    return null;
  }

  // Butona "Ekleniyor..." / "Sepete Eklendi ✓" / hata durumu göster
  function setAddButtonState(state, message) {
    const btn = findAddToCartButton();
    if (!btn) return;

    if (!btn.dataset.setMultiplierOriginalHtml) {
      btn.dataset.setMultiplierOriginalHtml = btn.innerHTML;
    }
    const original = btn.dataset.setMultiplierOriginalHtml;

    // Buton içindeki metin span'ini bul (tema bazen <span> sarıyor)
    const setLabel = (txt) => {
      const span = btn.querySelector('span:not(.sr-only)');
      if (span) { span.textContent = txt; } else { btn.textContent = txt; }
    };

    clearTimeout(btn._setMultiplierTimer);

    if (state === 'loading') {
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('set-multiplier-btn--loading');
      btn.disabled = true;
      setLabel(message || 'Ekleniyor…');
    } else if (state === 'success') {
      btn.setAttribute('aria-busy', 'false');
      btn.classList.remove('set-multiplier-btn--loading');
      btn.classList.add('set-multiplier-btn--success');
      btn.disabled = false;
      setLabel(message || 'Sepete Eklendi ✓');
      btn._setMultiplierTimer = setTimeout(() => {
        btn.classList.remove('set-multiplier-btn--success');
        btn.innerHTML = original;
      }, 2500);
    } else if (state === 'error') {
      btn.setAttribute('aria-busy', 'false');
      btn.classList.remove('set-multiplier-btn--loading');
      btn.classList.add('set-multiplier-btn--error');
      btn.disabled = false;
      setLabel(message || 'Eklenemedi');
      btn._setMultiplierTimer = setTimeout(() => {
        btn.classList.remove('set-multiplier-btn--error');
        btn.innerHTML = original;
      }, 3000);
    } else {
      // reset
      btn.setAttribute('aria-busy', 'false');
      btn.classList.remove('set-multiplier-btn--loading', 'set-multiplier-btn--success', 'set-multiplier-btn--error');
      btn.disabled = false;
      btn.innerHTML = original;
    }
  }

  async function handleSetCartRequest(originalFetch, url, options) {
    const requestSignature = createRequestSignature(options.body);

    if (processedRequests.has(requestSignature)) {
      return new Response(JSON.stringify({
        status: 'success',
        message: 'Request already processed',
        duplicate: true
      }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    processedRequests.add(requestSignature);

    if (isProcessingRequest) {
      return new Response(JSON.stringify({
        status: 'success',
        message: 'Set işleniyor...',
        processing: true
      }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    isProcessingRequest = true;
    setAddButtonState('loading');

    try {
      const userQuantity = getQuantityFromData(options.body);
      let addResults;

      if (isBedenSetiFormat) {
        const selectedVariantId = getVariantIdFromData(options.body);
        addResults = await addBedenSetiToCart(originalFetch, userQuantity, selectedVariantId, url, options);
      } else {
        addResults = await addTraditionalSetToCart(originalFetch, userQuantity, url, options);
      }

      if (addResults.success) {
        setTimeout(() => {
          triggerCartEvents({ item_count: addResults.totalAdded });
        }, 100);

        setTimeout(() => updateCartCount(), 300);

        // NOT: Sepet drawer popup'ı açılmıyor (kullanıcı istemiyor). Sadece sepet sayacı güncellenir.
        // Butonda "Sepete Eklendi ✓" geri bildirimi göster.
        setAddButtonState('success', `Sepete Eklendi ✓ (${addResults.totalAdded} adet)`);

        const formatInfo = isBedenSetiFormat ? ' (Beden Seti)' :
          isPaketYapisiFormat ? ' (Paket)' : ' (Set)';
        return new Response(JSON.stringify({
          status: 'success',
          message: `${userQuantity}${formatInfo} (${addResults.totalAdded} adet) ürün eklendi`,
          details: addResults.details,
          format: isBedenSetiFormat ? 'beden_seti' :
            isPaketYapisiFormat ? 'paket_yapisi' : 'traditional', id: Date.now(),
          quantity: addResults.totalAdded,
          variant_id: 'multiple',
          line_price: 0,
          sections: {
            'cart-drawer': '<div>Updated cart content</div>',
            'cart-icon-bubble': `<span>${addResults.totalAdded}</span>`
          }
        }), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        });
      } else {
        logError('Set adding failed:', addResults.errors);
        setAddButtonState('error', 'Eklenemedi');

        // Hata mesajını kullanıcıya göster
        return new Response(JSON.stringify({
          status: 'error',
          message: addResults.errors.join('\n'),
          description: 'Set bütünlüğü korunamadığı için ürün sepete eklenemedi.'
        }), {
          status: 422,
          headers: { 'Content-Type': 'application/json' }
        });
      }

    } catch (error) {
      logError('Set request error:', error);
      setAddButtonState('error', 'Eklenemedi');
      return originalFetch.call(this, url, options);

    } finally {
      // İşlem bayrağını hemen sıfırla (daha responsive olması için)
      setTimeout(() => {
        isProcessingRequest = false;
      }, 100);

      // Request signature'ı biraz sonra temizle (duplicate önleme için)
      setTimeout(() => {
        processedRequests.delete(requestSignature);
      }, 5000);
    }
  }

  async function addBedenSetiToCart(originalFetch, userQuantity, selectedVariantId, originalUrl, originalOptions) {
    let selectedRange = null;
    let multiplier = 1;

    const variantSize = getVariantSize(selectedVariantId);

    for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
      if (isSizeInRange(variantSize, range)) {
        selectedRange = range;
        multiplier = rangeMultiplier;
        break;
      }
    }

    // Fallback: 7026 gibi ürünlerde description tek range belirtir ama ürünün birden fazla compound variant'ı vardır
    // ((24-29), (26-31), (28-33) gibi). Bu durumda variant adı distribution'da bulunamaz —
    // distribution'ın ilk multiplier'ını default olarak kullan (compound paketler aynı boyutta varsayılır).
    if (!selectedRange) {
      const ranges = Object.entries(variantDistributions);
      if (ranges.length > 0) {
        const cleanSize = String(variantSize).replace(/[()]/g, '').trim();
        selectedRange = cleanSize || ranges[0][0];
        multiplier = ranges[0][1];
        log(`No exact range match for "${variantSize}" → using fallback multiplier ${multiplier} (default range "${selectedRange}")`);
      }
    }

    if (!selectedRange) {
      return {
        success: false,
        errors: [`Seçilen variant için uygun aralık bulunamadı: ${variantSize}`],
        details: [],
        totalAdded: 0
      };
    }

    const finalQuantity = userQuantity * multiplier;

    const stockInfo = sizeVariantStocks[selectedVariantId];
    if (!stockInfo || stockInfo.stock < finalQuantity) {
      return {
        success: false,
        errors: [`Stok yetersiz: ${stockInfo ? stockInfo.stock : 0} < ${finalQuantity}`],
        details: [],
        totalAdded: 0
      };
    }

    try {
      const newRequestBody = createSizeRequestBody(originalOptions.body, selectedVariantId, finalQuantity);

      const sizeOptions = {
        ...originalOptions,
        body: newRequestBody,
        headers: {
          ...originalOptions.headers,
          [internalRequestFlag]: 'true'
        }
      };

      const response = await originalFetch.call(this, originalUrl, sizeOptions);

      if (response.ok) {
        return {
          success: true,
          errors: [],
          details: [`${selectedRange}: ${finalQuantity} adet`],
          totalAdded: finalQuantity
        };
      } else {
        const errorText = await response.text();
        return {
          success: false,
          errors: [`HTTP ${response.status}: ${errorText}`],
          details: [],
          totalAdded: 0
        };
      }

    } catch (error) {
      return {
        success: false,
        errors: [`Network error: ${error.message}`],
        details: [],
        totalAdded: 0
      };
    }
  }

  function getVariantSize(variantId) {
    const stockInfo = sizeVariantStocks[variantId];
    if (stockInfo) {
      return stockInfo.sizeName;
    }

    const variantIndex = allSizeVariants.indexOf(variantId);
    if (variantIndex !== -1 && variantIndex < availableSizes.length) {
      return availableSizes[variantIndex];
    }

    return 'UNKNOWN';
  }

  function isSizeInRange(size, range) {
    const cleanSize = size.replace(/[()]/g, '').trim();
    const cleanRange = range.trim();

    if (cleanSize === cleanRange) {
      return true;
    }

    const rangeParts = cleanRange.split('-');
    if (rangeParts.length !== 2) {
      return false;
    }

    const rangeStart = parseInt(rangeParts[0]);
    const rangeEnd = parseInt(rangeParts[1]);

    if (cleanSize.includes('-')) {
      const sizeParts = cleanSize.split('-');
      if (sizeParts.length === 2) {
        const sizeStart = parseInt(sizeParts[0]);
        const sizeEnd = parseInt(sizeParts[1]);
        return sizeStart === rangeStart && sizeEnd === rangeEnd;
      }
    } else {
      const sizeNum = parseInt(cleanSize);
      if (!isNaN(sizeNum) && !isNaN(rangeStart) && !isNaN(rangeEnd)) {
        return sizeNum >= rangeStart && sizeNum <= rangeEnd;
      }
    }

    return false;
  }

  async function addTraditionalSetToCart(originalFetch, userQuantity, originalUrl, originalOptions) {
    const results = {
      success: true,
      errors: [],
      details: [],
      totalAdded: 0
    };

    const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

    if (isSTDFormat) {
      const stdQuantity = sizeDistribution['STD'];
      const finalQty = stdQuantity * userQuantity;

      // Kullanıcının seçtiği variant'ı kullan (renk varyantları için kritik!).
      // Yoksa fallback olarak ilk variant (Pure Scarfs-benzeri tek-variant ürünler için).
      const selectedId = getSelectedVariant();
      const variantId = (selectedId && sizeVariantStocks[selectedId]) ? selectedId : allSizeVariants[0];
      log(`STD: using variant ${variantId} (selected: ${selectedId})`);
      if (!variantId) {
        return {
          success: false,
          errors: ['Variant bulunamadı'],
          details: [],
          totalAdded: 0
        };
      }

      let hasStock = true;
      let availableStock = 999999;

      const stockInfo = sizeVariantStocks[variantId];
      if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null) {
        availableStock = stockInfo.stock;
        if (stockInfo.stock < finalQty) {
          hasStock = false;
        }
      }

      if (!hasStock) {
        return {
          success: false,
          errors: [`Stok yetersiz: ${availableStock} < ${finalQty}`],
          details: [],
          totalAdded: 0
        };
      }

      try {
        const newRequestBody = createSizeRequestBody(originalOptions.body, variantId, finalQty);

        const sizeOptions = {
          ...originalOptions,
          body: newRequestBody,
          headers: {
            ...originalOptions.headers,
            [internalRequestFlag]: 'true'
          }
        };

        log(`STD Format: Adding ${finalQty} items of variant ${variantId}`);

        const response = await originalFetch.call(this, originalUrl, sizeOptions);

        if (response.ok) {
          results.details.push(`STD: ${finalQty} adet`);
          results.totalAdded += finalQty;
          log(`STD Success: ${finalQty} items added`);
        } else {
          const errorText = await response.text();
          results.errors.push(`STD: HTTP ${response.status}`);
          logError(`STD failed: HTTP ${response.status}`, errorText);
        }

      } catch (error) {
        results.errors.push(`STD: ${error.message}`);
        logError('STD network error:', error);
      }

      // STD format işlemi tamamlandı, fonksiyondan çık
      return results;
    }

    const isPaketFormat = isPaketYapisiFormat;

    if (isPaketFormat) {
      const finalQty = paketMultiplier * userQuantity;

      const variantId = allSizeVariants[0];
      if (!variantId) {
        return {
          success: false,
          errors: ['Variant bulunamadı'],
          details: [],
          totalAdded: 0
        };
      }

      const stockInfo = sizeVariantStocks[variantId];
      if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null && stockInfo.stock < finalQty) {
        return {
          success: false,
          errors: [`Stok yetersiz: ${stockInfo.stock} < ${finalQty}`],
          details: [],
          totalAdded: 0
        };
      }

      try {
        const newRequestBody = createSizeRequestBody(originalOptions.body, variantId, finalQty);

        const sizeOptions = {
          ...originalOptions,
          body: newRequestBody,
          headers: {
            ...originalOptions.headers,
            [internalRequestFlag]: 'true'
          }
        };

        log(`Paket Format: Adding ${finalQty} items of variant ${variantId}`);

        const response = await originalFetch.call(this, originalUrl, sizeOptions);

        if (response.ok) {
          results.details.push(`Paket: ${finalQty} adet`);
          results.totalAdded += finalQty;
          log(`Paket Success: ${finalQty} items added`);
        } else {
          const errorText = await response.text();
          results.errors.push(`Paket: HTTP ${response.status}`);
          logError(`Paket failed: HTTP ${response.status}`, errorText);
        }

      } catch (error) {
        results.errors.push(`Paket: ${error.message}`);
        logError('Paket network error:', error);
      }

      // Paket format işlemi tamamlandı, fonksiyondan çık
      return results;
    }

    // Traditional set format (her beden için ayrı ayrı ekleme)
    if (!isSTDFormat && !isPaketFormat) {
      // Set bütünlüğü kontrolü
      const validation = validateSetIntegrity(userQuantity, sizeDistribution);

      if (!validation.isValid) {
        return {
          success: false,
          errors: validation.errors,
          details: [],
          totalAdded: 0
        };
      }

      log(`Set integrity validated. Adding ${userQuantity} sets...`);

      for (const [size, baseQty] of Object.entries(sizeDistribution)) {
        const finalQty = baseQty * userQuantity;
        const variantId = findVariantIdBySize(size);

        if (!variantId) {
          results.errors.push(`${size} bedeni bulunamadı`);
          continue;
        }

        const stockInfo = sizeVariantStocks[variantId];
        if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null && stockInfo.stock < finalQty) {
          results.errors.push(`${size} stok yetersiz: ${stockInfo.stock} < ${finalQty}`);
          continue;
        }

        try {
          const newRequestBody = createSizeRequestBody(originalOptions.body, variantId, finalQty);

          const sizeOptions = {
            ...originalOptions,
            body: newRequestBody,
            headers: {
              ...originalOptions.headers,
              [internalRequestFlag]: 'true'
            }
          };

          const response = await originalFetch.call(this, originalUrl, sizeOptions);

          if (response.ok) {
            results.details.push(`${size}: ${finalQty} adet`);
            results.totalAdded += finalQty;
            log(`${size} added successfully: ${finalQty} items`);
          } else {
            const errorText = await response.text();
            results.errors.push(`${size}: HTTP ${response.status}`);
            logError(`${size} failed: HTTP ${response.status}`, errorText);
          }

          await new Promise(resolve => setTimeout(resolve, 500));

        } catch (error) {
          results.errors.push(`${size}: ${error.message}`);
          logError(`${size} network error:`, error);
        }
      }

      if (results.errors.length > 0) {
        results.success = false;
      }

      return results;
    }

    // Hiçbir format eşleşmedi, boş sonuç döndür
    return results;
  }

  function createSizeRequestBody(originalBody, variantId, quantity) {
    if (originalBody instanceof FormData) {
      const newFormData = new FormData();
      for (let [key, value] of originalBody.entries()) {
        if (key === 'id' || key === 'variant_id') {
          newFormData.append(key, variantId);
        } else if (key === 'quantity') {
          newFormData.append(key, quantity);
        } else {
          newFormData.append(key, value);
        }
      }

      if (!newFormData.has('id')) {
        newFormData.append('id', variantId);
      }
      if (!newFormData.has('quantity')) {
        newFormData.append('quantity', quantity);
      }

      return newFormData;
    }

    if (typeof originalBody === 'string') {
      try {
        const json = JSON.parse(originalBody);
        json.id = variantId;
        json.quantity = quantity;
        return JSON.stringify(json);
      } catch (e) {
        let result = originalBody;
        result = result.replace(/[?&]id=([^&]+)/g, `id=${variantId}`);
        result = result.replace(/[?&]quantity=([^&]+)/g, `quantity=${quantity}`);
        if (!result.includes('id=')) {
          result += (result.includes('?') ? '&' : '?') + `id=${variantId}`;
        }
        if (!result.includes('quantity=')) {
          result += `&quantity=${quantity}`;
        }
        return result;
      }
    }

    const fallbackFormData = new FormData();
    fallbackFormData.append('id', variantId);
    fallbackFormData.append('quantity', quantity);
    return fallbackFormData;
  }

  function createRequestSignature(data) {
    const userQty = getQuantityFromData(data);
    const timestamp = Date.now();
    const baseSignature = `qty-${userQty}-time-${Math.floor(timestamp / 5000)}`;
    return baseSignature;
  }

  function getQuantityFromData(data) {
    if (!data) return 1;

    let quantity = 1;

    try {
      if (data instanceof FormData) {
        quantity = parseInt(data.get('quantity')) || 1;
      } else if (typeof data === 'string') {
        try {
          const json = JSON.parse(data);
          quantity = parseInt(json.quantity) || 1;
        } catch (e) {
          const match = data.match(/quantity=(\d+)/);
          quantity = match ? parseInt(match[1]) : 1;
        }
      }
    } catch (e) {
      quantity = 1;
    }

    quantity = Math.max(1, Math.floor(Math.abs(quantity)));
    return quantity;
  }

  function getVariantIdFromData(data) {
    if (!data) return 'unknown';

    try {
      if (data instanceof FormData) {
        return data.get('id') || data.get('variant_id') || 'unknown';
      }

      if (typeof data === 'string') {
        try {
          const json = JSON.parse(data);
          return json.id || json.variant_id || 'unknown';
        } catch (e) {
          const idMatch = data.match(/[?&]id=([^&]+)/);
          return idMatch ? idMatch[1] : 'unknown';
        }
      }
    } catch (e) {
      return 'unknown';
    }

    return 'unknown';
  }

  function triggerCartEvents(cart) {
    try {
      // Validate cart object
      const safeCart = cart || {};
      const itemCount = safeCart.item_count || 0;

      const cartUpdateEvent = new CustomEvent('cart:updated', {
        detail: { cart: safeCart }
      });
      document.dispatchEvent(cartUpdateEvent);

      const events = [
        'cart:update',
        'cart:refresh',
        'cartUpdated',
        'cart-updated',
        'ajaxCart:update'
      ];

      events.forEach(eventName => {
        try {
          const event = new CustomEvent(eventName, {
            detail: { cart: safeCart, itemCount: itemCount }
          });
          document.dispatchEvent(event);
        } catch (e) {
          log('Error dispatching event:', eventName, e.message);
        }
      });

      if (window.jQuery && typeof window.jQuery === 'function') {
        try {
          window.jQuery(document).trigger('cart:updated', [safeCart]);
          window.jQuery(document).trigger('cartUpdated', [safeCart]);
        } catch (e) {
          log('Error triggering jQuery events:', e.message);
        }
      }
    } catch (e) {
      logError('Error in triggerCartEvents:', e.message);
    }
  }

  function updateCartDrawer() {
    try {
      // Method 1: Try cart-drawer custom element
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          log('Cart drawer opened via custom element');
          return;
        } else if (typeof cartDrawer.show === 'function') {
          cartDrawer.show();
          log('Cart drawer opened via show method');
          return;
        }
      }

      // Method 2: Try theme cart drawer
      if (window.theme && window.theme.cartDrawer) {
        if (typeof window.theme.cartDrawer.open === 'function') {
          window.theme.cartDrawer.open();
          log('Cart drawer opened via theme object');
          return;
        }
        if (typeof window.theme.cartDrawer.refresh === 'function') {
          window.theme.cartDrawer.refresh();
          log('Cart drawer refreshed via theme object');
        }
      }

      // Method 3: Try Shopify theme events
      if (typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        log('Cart refresh event dispatched');
      }

      // Method 4: Try cart drawer via class selector
      const cartDrawerClass = document.querySelector('.cart-drawer, #cart-drawer');
      if (cartDrawerClass && typeof cartDrawerClass.classList !== 'undefined') {
        cartDrawerClass.classList.add('active', 'is-active', 'open');
        log('Cart drawer activated via class manipulation');
      }
    } catch (e) {
      logError('Error opening cart drawer:', e.message);
    }
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(cart => {
        if (!cart) {
          logError('Cart data is null or undefined');
          return;
        }

        const itemCount = cart.item_count || 0;
        const cartCounters = document.querySelectorAll(
          '.cart-count, [data-cart-count], .cart-item-count, #cart-icon-bubble, .cart-counter'
        );

        cartCounters.forEach(counter => {
          if (counter) {
            counter.textContent = itemCount;
            if (counter.setAttribute) {
              counter.setAttribute('data-cart-count', itemCount);
            }
          }
        });

        triggerCartEvents(cart);

        log('Cart updated:', itemCount);
      })
      .catch(error => {
        logError('Cart update error:', error.message || error);
      });
  }

  forceMultiplier();

})();